import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__halfstar",
  "use": "icon__halfstar-usage",
  "viewBox": "0 0 510 510",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 510 510\" id=\"icon__halfstar\"><path d=\"M510 197.472l-183.37-15.734L255 12.75l-71.629 168.988L0 197.472l139.103 120.539L97.41 497.25 255 402.186l157.59 95.039-41.692-179.239L510 197.472zM255 354.348V117.172l43.605 102.918 111.689 9.588-84.711 73.389 25.398 109.166L255 354.348z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol